import { AxiosError } from 'axios';
import { logError } from './logger';

export const errorParser = (error: AxiosError) => {
  logError('Api Error', error);

  // TODO: Parse error better
  return 'Unknown error occurred';
};
